// All static strings, config, and magic numbers for Private Chat feature
export const MAX_NAME_LENGTH = 15;
export const LOADING_TEXT = "Loading...";
export const NAME_INPUT_PLACEHOLDER = "Enter your nickname";
export const NAME_INPUT_HEADER = "Welcome to the Chat";
export const NAME_INPUT_DESCRIPTION = "Please enter your nickname(max 15 characters) to start chatting";
export const START_CHATTING_LABEL = "Start Chatting";
export const CHANGE_NICKNAME_LABEL = "Change Nickname";
export const START_NEW_CHAT_LABEL = "Start New Chat";
export const CANCEL_LABEL = "Cancel";
export const UNDERSTOOD_LABEL = "Understood";
export const BLOCKED_HEADER = "Access Denied";
export const BLOCKED_DESCRIPTION = "You have been blocked from sending messages to this shop. This means you cannot send any more messages to this shop.";
export const CLOSE_CHAT_HEADER = "Close Chat";
export const CLOSE_CHAT_DESCRIPTION = "Do you want to close the chat?";
export const BLOCK_USER_HEADER = "Block user";
export const BLOCK_USER_DESCRIPTION = "Do you want to block this user?";
export const NAME_DIALOG_HEADER = "Change Your Nickname";
export const NAME_DIALOG_NEW_LABEL = "New Nickname (max 15 characters)";
export const CHAR_COUNTER_LABEL = "characters left";
export const SPAM_HEADER = "Chat Marked as Spam";
export const SPAM_DESCRIPTION = "This chat has been marked as spam due to excessive buzzing. You will no longer be able to send messages to this shop.";
export const SPAM_WARNING_HEADER = "Spam Warning";
export const SPAM_WARNING_DESCRIPTION = "Warning: Excessive buzzing may be considered spam. One more buzz will result in this chat being marked as spam and no longer appearing at the top of the shop's chat list.";
export const START_NEW_CHAT_CONFIRM_HEADER = "Start New Chat?";
export const START_NEW_CHAT_CONFIRM_DESCRIPTION = "Changing your nickname will start a new chat. Do you want to proceed?";
export const PI_CHECK_ICON = "pi pi-check";
export const PI_TIMES_ICON = "pi pi-times";
export const PI_BAN_ICON = "pi pi-ban";
export const PI_EXCLAMATION_TRIANGLE_ICON = "pi pi-exclamation-triangle";
